"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderIdToManagementUrl = transformOrderIdToManagementUrl;
function transformOrderIdToManagementUrl(orderId) {
    return `http://management.mydaytrip.com/#/order?orderId=${orderId}`;
}
//# sourceMappingURL=transformOrderIdToManagementUrl.js.map